export default "__VITE_ASSET__CBFu7rPr__"